export default {
  SET_ROUTES ( state, payload){
    state.routes = payload
  },
  SET_ROUTE ( state, payload){
    state.route = payload
  },
  SET_ZONE_ID(state, value){
    state.zone_id = value;
  },
  SET_CURRENT_PAGE(state, payload) {
    state.currentPage = payload
  },
  SET_STATION_PAGE(state, payload) {
    state.stationPage = payload
  }
}
